import { checkRequired, useFormContext } from '../../../hoc/form';

export default function FormConditionalSection({ require, children }) {
	const context = useFormContext();
	if(!context || !checkRequired(require, context.values)) {
		return null;
	}
	return children;
}
